export default "__VITE_ASSET__DxRH1WpN__"